var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "#4CB4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.6396,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#E5F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6666 69.6667V73C50.6666 73.8841 51.0178 74.7319 51.6429 75.357C52.2681 75.9821 53.1159 76.3333 54 76.3333H74C74.884 76.3333 75.7319 75.9821 76.357 75.357C76.9821 74.7319 77.3333 73.8841 77.3333 73V69.6667M55.6666 59.6667L64 68M64 68L72.3333 59.6667M64 68V48",
    stroke: "#4CB4FF",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventDownload);
export default __webpack_public_path__ + "static/media/canvas_event_download.0905e75cd491491e5a066e6983e25830.svg";
export { ForwardRef as ReactComponent };